import { createFileRoute } from '@tanstack/react-router';
import { PersonSentRoute } from './-route-wrappers';

/** The person profile's Sent tab at its own URL (FPS-2712). */
function PersonSentIndexRoute() {
  return <PersonSentRoute />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/people/$personId/sent/')({
  component: PersonSentIndexRoute,
});
